import React,{useState} from 'react'
import Singular from './Singular'
import List from './List';
import SingularDashboard from './SingularDashboard';
export default function Main({setmargin}) {
    const [viewState,setViewState] =useState('SingularDashboard');

  return (
    <>
<div className="row fixed-top" style={{ marginTop: setmargin?'78px':'8px',zIndex:'2' }}>
                <div className={`col-sm-4 col-xs-6 expenseTabs ${ viewState == "SingularDashboard" ? "active" : ""}`} onClick={() => setViewState('SingularDashboard')} style={{  width:"calc(100% /3)" }}>
                Singular Dashboard

                </div>
                <div className={`col-sm-4 col-xs-6 expenseTabs ${ viewState == "list" ? "active" : ""}`} onClick={() => setViewState('list')} style={{width:"calc(100% /3)"}}>
                     Listing

                </div>
                <div className={`col-sm-4 col-xs-6 expenseTabs ${ viewState == "upload" ? "active" : ""}`} onClick={() => setViewState('upload')} style={{ width:"calc(100% /3)" }}>
                  Upload Logs

                </div>

            </div>
            
            <div className="full-height">
                {viewState === 'list' ?
                    <List />
                    : ""}
                {viewState === 'upload' ?
                    <Singular/>
                    : ""}
                {viewState === 'SingularDashboard' ?
                    <SingularDashboard/>
                    : ""}
            </div>
    </>
  )
}
